import { RenderedDie } from "@/components/RenderedDie";
import { useRenderedDiceStore } from "@/hooks/useRenderedDiceStore";

export const RenderedDice = () => {
  const ids = useRenderedDiceStore((state) => state.renderedDice.ids);

  return ids.map((id: string) => <RenderedDie key={`${id}-die`} id={id} />);
};
